<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Turma
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="turma">
        <v-card color="green lighten-1" class="mb-5" outlined>
          <v-card-title> Turma: {{ turma.descricao }}</v-card-title>
          <v-card-subtitle class="font-weight-medium">
            <div>
              Professor(a): <strong>{{ professor.nome || "- - -" }}</strong>
            </div>
            <div>
              Total de alunos: <strong>{{ matriculas.length || "- - -" }}</strong>
            </div>
            <div>
              Tipo de atendimento: <strong>{{ turma.tipo_de_atendimento || "- - -" }}</strong> |
              Tipo de ensino:
              <strong>{{ turma.curso?.descricao || "- - -" }}</strong>
            </div>
            <div>
              Tipo de relatório:
              <strong>{{ turma.sistema_bncc_id > 0 ? "BNCC" : "- - -" }}</strong>
            </div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mt-3">
      <template>
        <v-tabs v-model="tab_atual" background-color="primary" dark>
          <v-tab v-for="tab of tabs" :key="tabs.indexOf(tab)">{{ tab.descricao }}</v-tab>
        </v-tabs>
        <div class="text-right">
          <v-btn color="primary" class="ml-4 mt-4 mr-4 white--text" @click="gerarRelatorio">
            Lista da turma
            <v-icon right dark> mdi-file </v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-simple-table v-if="matriculas" class="elevation-1" v-show="tab_atual == 0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">N º</th>
                  <th class="text-left" width="300px">Aluno</th>
                  <th class="text-center" width="15%">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="matricula of matriculas"
                  :key="matricula.id"
                  :class="!matricula.aluno ? 'accent' : ''"
                >
                  <td width="20">{{ matriculas.indexOf(matricula) + 1 }}</td>
                  <td class="font-weight-medium text-left">
                    <div>
                      {{
                        matricula.aluno
                          ? matricula.aluno.nomecompleto
                          : `[ALUNO POSSIVELMENTE DELETADO] MATRICULA: ${matricula.id}`
                      }}
                    </div>
                    <div>
                      <small>
                        {{ matricula.aluno?.codigo_inep || "- - -" }} /
                        {{ matricula.aluno?.codigo || "- - -" }}
                      </small>
                    </div>
                  </td>
                  <td class="text-center">
                    <v-tooltip bottom v-if="turma.sistema_bncc_id ? true : false">
                      <!-- v-if="matricula.aluno?.especial === 0 && turma?.curso_id !== 3" -->
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-1"
                          color="blue lighten-3"
                          v-bind="attrs"
                          v-on="on"
                          :to="{
                            name: 'relatorios.lancarRelatorioBNCC',
                            params: { matricula_id: matricula.id },
                          }"
                        >
                          <v-icon small>fa fa-file-invoice</v-icon>
                        </v-btn>
                      </template>
                      <span>Lançar relatório da(e) {{ turma.curso.descricao }}</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="turma.sistema_bncc_id ? true : false">
                      <!-- v-if="matricula.aluno?.especial === 0 && turma?.curso_id !== 3" -->
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-2"
                          color="red lighten-5"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => RelatorioBNCC(matricula.id)"
                        >
                          <v-icon color="red lighten-1" small> fa fa-file-pdf</v-icon>
                        </v-btn>
                      </template>
                      <span> Gerar relatório da(e) {{ turma.curso.descricao }}</span>
                    </v-tooltip>

                    <!-- PARA ALUNOS ESPECIAIS -->
                    <v-tooltip bottom v-if="matricula.aluno?.especial == 1 || turma.curso_id === 3">
                      <!-- v-if="matricula.aluno.especial == 1 && turma.curso_id === 3" -->
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-1"
                          color="blue lighten-3"
                          v-bind="attrs"
                          v-on="on"
                          :to="{
                            name: 'educacaoInclusiva.atendimentos',
                            params: { matricula_id: matricula.id },
                          }"
                        >
                          <v-icon small>fa fa-universal-access</v-icon>
                        </v-btn>
                      </template>
                      <span>Relatório Diário AEE</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="matricula.aluno.especial === 1 || turma.curso_id === 3">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-1"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="abrirModalLancamentos(matricula)"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Visualizar/Editar Lançamentos AEE</span>
                    </v-tooltip>

                    <v-tooltip
                      bottom
                      v-if="matricula.aluno?.especial === 1 || turma.curso_id === 3"
                    >
                      <!-- v-if="matricula.aluno.especial === 1 && turma.curso_id === 3" -->
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-2"
                          color="red lighten-5"
                          v-bind="attrs"
                          v-on="on"
                          @click="() => relatorioAee(matricula.id)"
                        >
                          <v-icon color="red lighten-1" small> fa fa-file-pdf</v-icon>
                        </v-btn>
                      </template>
                      <span>Relatório AEE (ATENDIMENTO EDUCACIONAL ESPECIALIZADO)</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="matricula.aluno?.especial == 1 || turma.curso_id === 3">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          class="ml-1"
                          color="blue lighten-3"
                          v-bind="attrs"
                          v-on="on"
                          :to="{
                            name: 'educacaoInclusiva.planoBimestralAluno',
                            params: { matricula_id: matricula.id },
                          }"
                        >
                          <v-icon small>fa fa-book</v-icon>
                        </v-btn>
                      </template>
                      <span>Plano Bimestral AEE</span>
                    </v-tooltip>

                    <v-menu
                      v-if="matricula.aluno?.especial == 1 || turma.curso_id === 3"
                      offset-y
                      left
                    >
                      <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
                            <v-btn
                              x-small
                              class="ml-1"
                              color="blue lighten-5"
                              v-bind="{ ...attrsMenu, ...attrsTooltip }"
                              v-on="{ ...onMenu, ...onTooltip }"
                            >
                              <v-icon color="red darken-3" small>fa fa-file-pdf</v-icon>
                            </v-btn>
                          </template>
                          <span>Imprimir Plano Bimestral AEE</span>
                        </v-tooltip>
                      </template>
                      <v-list dense>
                        <v-list-item
                          v-for="bimestre of $constants.bimestres"
                          :key="bimestre.value"
                          @click="() => imprimirPlanoBimestralAEE(matricula.id, bimestre.value)"
                        >
                          <v-list-item-title class="pa-2">{{ bimestre.desc }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </template>
    </v-card>
    <e-modal-lancamentos-aee :dialog.sync="modalLancamentos" :matricula-id="currentMatriculaId" />
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      turma: null,
      professor: null,
      matriculas: null,
      gestoes_de_aulas: null,
      tab_atual: 0,
      tabs: [
        {
          id: 0,
          descricao: "Lista da Turma",
        },
      ],
      modalLancamentos: false,
      currentMatriculaId: null,
    };
  },
  async mounted() {
    await this.loadBasicData();
  },
  methods: {
    abrirModalLancamentos(matricula) {
      this.currentMatriculaId = matricula.id;
      this.modalLancamentos = true;
    },
    async gerarRelatorio() {
      this.$loaderService.open("Carregando dados...");
      await this.$services.relatoriosService.listarTurma(parseInt(this.$route.params.turmaId, 10));
      this.$loaderService.close();
    },
    async RelatorioBNCC(matricula_id) {
      this.$loaderService.open("Carregando dados...");
      await this.$services.relatoriosService.relatorioBNCC(parseInt(matricula_id, 10));
      this.$loaderService.close();
    },
    async relatorioAee(matricula_id) {
      this.$loaderService.open("Carregando dados...");
      await this.$services.relatoriosService.relatorioAee(parseInt(matricula_id, 10));
      this.$loaderService.close();
    },
    async imprimirPlanoBimestralAEE(matricula_id, bimestre) {
      this.$loaderService.open("Gerando plano bimestral AEE...");
      try {
        await this.$services.planosBimestraisAEEService.pdf(
          parseInt(matricula_id, 10),
          parseInt(bimestre, 10)
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async loadBasicData() {
      this.$loaderService.open("Carregando dados...");
      try {
        const payload = await this.$services.gestoesDeAulasAEEService.visualizarTurma(
          parseInt(this.$route.params.gestaoDeAulasId, 10)
        );
        this.turma = payload?.turma;
        this.professor = payload?.professor;
        this.matriculas = payload?.turma.matriculas;
      } catch (error) {
        this.$handleError(error);
      }

      this.$loaderService.close();
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.v-data-table >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}
</style>
